module.exports = __webpack_public_path__ + "img/9788952214546.a26f254e.jpg";